import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util';
import {
  ConsultaLoteRetorno,
  ConsultaLotesRetorno,
  CriarInventarioPayload,
  FecharPayload,
  InventarioDto,
  InventarioLista,
  GerarExcel,
} from '../interface/inventario';

@Injectable({ providedIn: 'root' })
export class InventarioService {

  url = `${environment.urlApiProtheus}/wsrinventario`;

  constructor(
    private http: HttpClient,
    private utilService: UtilService,
  ) {}

  lista(): Observable<InventarioLista> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<InventarioLista>(`${this.url}/lista`, httpOptions);
  }

  getInventario(CZ08COD: string): Observable<InventarioDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<InventarioDto>(`${this.url}/${CZ08COD}`, httpOptions);
  }

  criarInventario(payload: CriarInventarioPayload): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}`, payload, httpOptions);
  }

  atualizarInventario(CZ08COD: string, payload: CriarInventarioPayload): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.put(`${this.url}/${CZ08COD}`, payload, httpOptions);
  }

  excluirInventario(CZ08COD: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/${CZ08COD}`, httpOptions);
  }

  encerrarInventario(CZ08COD: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/encerrar/${CZ08COD}`, null, httpOptions);
  }

  consultarLotes(payload: CriarInventarioPayload): Observable<ConsultaLotesRetorno> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<ConsultaLotesRetorno>(`${this.url}/lotes/consulta`, payload, httpOptions);
  }

  consultarLote(CZ08LOTE: string): Observable<ConsultaLoteRetorno> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<ConsultaLoteRetorno>(`${this.url}/consultalote/${CZ08LOTE}`, httpOptions);
  }

  fecharArea(CZ08COD: string, payload: FecharPayload): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/fechar/${CZ08COD}`, payload, httpOptions);
  }

  gerarExcel(payload: GerarExcel): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/excel`, payload, httpOptions);
  }
}
